<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="24" :sm="num" :lg="num" class="card-panel-col">
      <div class="card-panel" v-show="ltWitch">
        <div class="card-panel-icon-switch">
          <svg-icon icon-class="switch" class-name="icon-switch" @click.prevent="ltWitch=!ltWitch"/>
        </div>
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="china-unicom"  class-name="card-panel-icon"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            中国联通
          </div>
          <el-statistic group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.showMonthFlow.ltMonthFlow" class="card-panel-num">
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
          <el-statistic style="color:red"  v-if="adminShow" group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.monthFlow.ltMonthFlow" class="card-panel-num">
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
        </div>
      </div>
      <div class="card-panel" v-show="!ltWitch">
        <div class="card-panel-icon-switch">
          <svg-icon icon-class="switch" class-name="icon-switch" @click="ltWitch=!ltWitch" />
        </div>
        <el-row align="middle" class="card-flow-title">
          <el-col :span="8">卡源</el-col>
          <el-col :span="8">平台</el-col>
          <el-col :span="8">运营商</el-col>
        </el-row>
        <div class="card-flow-list">
          <el-row v-for="(item,index) in sourceMonthFlow.sourceList.lt" :key="index" align="middle">
            <el-col :span="8">{{item.name}}</el-col>
            <el-col :span="8">{{item.monthFlow}}GB</el-col>
            <el-col :span="8">{{item.operatorMonthFlow}}GB</el-col>
          </el-row>
        </div>
      </div>
    </el-col>
    <el-col :xs="24" :sm="num" :lg="num" class="card-panel-col">
      <div class="card-panel" v-show="ydSwitch">
        <div class="card-panel-icon-switch" @click="ydSwitch=!ydSwitch">
          <svg-icon icon-class="switch" class-name="icon-switch"/>
        </div>
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon-class="china-mobile" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            中国移动
          </div>
          <el-statistic group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.showMonthFlow.ydMonthFlow" class="card-panel-num">
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
          <el-statistic style="color:red"  v-if="adminShow" group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.monthFlow.ydMonthFlow" class="card-panel-num">
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
        </div>
      </div>
      <div class="card-panel" v-show="!ydSwitch">
        <div class="card-panel-icon-switch" @click="ydSwitch=!ydSwitch">
          <svg-icon icon-class="switch" class-name="icon-switch"/>
        </div>
        <el-row align="middle" class="card-flow-title">
          <el-col :span="8">卡源</el-col>
          <el-col :span="8">平台</el-col>
          <el-col :span="8">运营商</el-col>
        </el-row>
        <div class="card-flow-list">
          <el-row v-for="(item,index) in sourceMonthFlow.sourceList.yd" :key="index" align="middle">
            <el-col :span="8">{{item.name}}</el-col>
            <el-col :span="8">{{item.monthFlow}}GB</el-col>
            <el-col :span="8">{{item.operatorMonthFlow}}GB</el-col>
          </el-row>
        </div>
      </div>
    </el-col>
    <el-col :xs="24" :sm="num" :lg="num" class="card-panel-col">
      <div class="card-panel" v-show="dxSwitch">
        <div class="card-panel-icon-switch" @click="dxSwitch=!dxSwitch">
          <svg-icon icon-class="switch" class-name="icon-switch"/>
        </div>
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="china-telecom" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            中国电信
          </div>
          <el-statistic group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.showMonthFlow.dxMonthFlow" class="card-panel-num" >
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
          <el-statistic style="color:red" v-if="adminShow" group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.monthFlow.dxMonthFlow" class="card-panel-num">
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
        </div>
      </div>
      <div class="card-panel" v-show="!dxSwitch">
        <div class="card-panel-icon-switch" @click="dxSwitch=!dxSwitch">
          <svg-icon icon-class="switch" class-name="icon-switch"/>
        </div>
        <el-row align="middle" class="card-flow-title">
          <el-col :span="8">卡源</el-col>
          <el-col :span="8">平台</el-col>
          <el-col :span="8">运营商</el-col>
        </el-row>
        <div class="card-flow-list">
          <el-row v-for="(item,index) in sourceMonthFlow.sourceList.dx" :key="index" align="middle">
            <el-col :span="8">{{item.name}}</el-col>
            <el-col :span="8">{{item.monthFlow}}GB</el-col>
            <el-col :span="8">{{item.operatorMonthFlow}}GB</el-col>
          </el-row>
        </div>
      </div>
    </el-col>
    <el-col :xs="24" :sm="num" :lg="num" class="card-panel-col" v-if="adminShow">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon-class="word" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            国际流量
          </div>
          <el-statistic group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.showMonthFlow.nationalMonthFlow" class="card-panel-num">
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
          <el-statistic style="color:red" group-separator="," :precision="2" decimal-separator="." :value="sourceMonthFlow.monthFlow.nationalMonthFlow" class="card-panel-num">
            <template slot="suffix">
              GB
            </template>
          </el-statistic>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import { monthFlow} from "@/api/api.js";//运营商的流量统计
export default {
  data() {
    return {
      // 流量统计
      sourceMonthFlow:{
        monthFlow:{},
        showMonthFlow:{},
        sourceList:[]
      },
      ltWitch:true,
      ydSwitch:true,
      dxSwitch:true
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1';
    },
    num(){
      return this.$store.getters.user.userType =='1' ? 6 : 8
    }
  },
  methods: {
    // js千位分割
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },
    // 运营商的流量统计
    handleMonthFlow(refresh){
      monthFlow({refresh}).then(res=>{
        this.sourceMonthFlow = res.data.data;
      });
    },
  },
  created(){
    if(this.adminShow){
      this.$nextTick(() => {
        this.handleMonthFlow(0);
      });
    }
    
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .card-flow-title{
    margin-top:6px;
    text-align:center;
    pointer-events: none;
  }
  .card-flow-list{
    height: 83px;
    margin-top:8px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width:12px;
    }
    &::-webkit-scrollbar-track {
        -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
        border-radius:10px;
    }
    &::-webkit-scrollbar-track{
        -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3);
        border-radius:10px;
        background-color:#F5F5F5;
    }
    .el-row{
      background: #e5e9f2;
      margin-bottom: 4px;
      text-align:center
    }
    .el-col {
      line-height: 22px;
    }
  }
  .panel-group {
    margin-top: 18px;

    .card-panel-col {
      margin-bottom: 32px;
    }

    .card-panel {
      height: 108px;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      border-radius: 8px;


      .card-panel-icon-switch{
        float: left;
        position: absolute;
        padding-top: 7px;
        padding-left: 6px;
        font-size: 16px;
        .svg-icon{
          margin: 2px 4px;
        }
      }
      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shopping {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 14px 0 0 14px;
        padding: 16px;
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        float: left;
        margin-top: -14px;
        font-size: 75px;
      }

      .card-panel-description {
        float: right;
        font-weight: bold;
        margin: 26px;
        margin-left: 0px;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }

</style>
